import React from 'react';
import classNames from 'classnames';
import s from './StoryCard.scss';

function iconType(iconSize, iconClassName, cardImageIcon, iconData) {
  switch (iconSize) {
    case 'primestory': {
      return <i className={`${s.toiplusIcon}`} />;
    }
    case 'primestorySmall': {
      return <i className={`${s.toiplusIcon} ${s.small}`} />;
    }
    case 'largeIcon': {
      return <i className={iconClassName}>{iconData || ''}</i>;
    }
    case 'smallIcon': {
      return <i className={cardImageIcon} />;
    }
    case 'payperstorytxt': {
      return (
        <i
          className={iconClassName}
          dangerouslySetInnerHTML={{
            __html: iconData || '',
          }}
        />
      );
    }
    default: {
      return null;
    }
  }
}

function Icon(
  isPhotoStory,
  isTypeVideo,
  duration,
  photosCount,
  isVisualStoryCard,
  isToiPlusStory,
  isIconSmall,
) {
  let iconData = '';
  let iconSize = 'largeIcon';
  const iconClassName = classNames({
    //provides layout;
    [s.mediavideothumb]: isTypeVideo,
    mediavideothumb: isTypeVideo,
    [s.mediaphotothumb]: isPhotoStory && !isVisualStoryCard,
    mediaphotothumb: isPhotoStory && !isVisualStoryCard,
    [s.visualstoryicon]: isVisualStoryCard,
    visualstoryicon: isVisualStoryCard,
  });

  const cardImageIcon = classNames({
    [s.newsVideo]: isTypeVideo,
    [s.newsPhoto]: isPhotoStory,
    newsVideo: isTypeVideo,
    newsPhoto: isPhotoStory,
  });

  if (isPhotoStory && !isIconSmall) {
    iconData = photosCount;
  } else if (isTypeVideo && !isIconSmall) {
    iconData = duration;
  }

  // iconSize = 'smallIcon';
  // if (isTOIPLeadImage && showPriceTag) {
  //   iconSize = 'payperstorytxt';
  // } else if (!isInlineSmallIconCard) {
  //   if (isToiPlusStory) {
  //     iconSize = 'primestory';
  //     if (isPaperStoryText) {
  //       iconSize = 'payperstorytxt';
  //     }
  //   } else {
  //     iconSize = 'largeIcon';
  //   }
  // } else if (isMobileInlineVideo || isInlineSmallIconCard) {
  //   if (isToiPlusStory) {
  //     iconSize = 'primestorySmall';
  //     if (isPaperStoryText) {
  //       iconSize = 'payperstorytxt';
  //     }
  //   } else {
  //     iconSize = 'smallIcon';
  //   }
  // }
  if (isToiPlusStory && !isVisualStoryCard) {
    iconSize = 'primestory';
    if (isIconSmall) {
      iconSize = 'primestorySmall';
    }
  }

  return <>{iconType(iconSize, iconClassName, cardImageIcon, iconData)}</>;
}

export default Icon;
